import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isLight ? 'Przełącz na ciemny motyw' : 'Przełącz na jasny motyw'}
      title={isLight ? 'Tryb ciemny' : 'Tryb jasny'}
      className={`inline-flex items-center justify-center rounded-full text-[var(--text-muted)] hover:text-[#C9A84C] hover:border-[#C9A84C] transition-colors ${className || 'w-9 h-9 border border-[var(--border-soft)]'}`}
    >
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
};
